/**
 * Genera una contraseña segura con crypto.getRandomValues.
 * Incluye mayúsculas, minúsculas, dígitos y símbolos; apta para Firebase Auth.
 */

const UPPER = "ABCDEFGHJKLMNPQRSTUVWXYZ";
const LOWER = "abcdefghijkmnopqrstuvwxyz";
const DIGITS = "23456789";
const SYMBOLS = "!@#$%&*-_=+?";
const ALL = UPPER + LOWER + DIGITS + SYMBOLS;

const DEFAULT_LENGTH = 16;

function randomIndex(max: number): number {
  const buffer = new Uint32Array(1);
  crypto.getRandomValues(buffer);
  return buffer[0]! % max;
}

function pick(charset: string): string {
  return charset[randomIndex(charset.length)]!;
}

/** Contraseña aleatoria de longitud fija (por defecto 16). */
export function generateSecurePassword(length = DEFAULT_LENGTH): string {
  const size = Math.max(length, 8);
  const chars: string[] = [
    pick(UPPER),
    pick(LOWER),
    pick(DIGITS),
    pick(SYMBOLS),
  ];

  for (let i = chars.length; i < size; i += 1) {
    chars.push(pick(ALL));
  }

  // Fisher–Yates con RNG criptográfico
  for (let i = chars.length - 1; i > 0; i -= 1) {
    const j = randomIndex(i + 1);
    [chars[i], chars[j]] = [chars[j]!, chars[i]!];
  }

  return chars.join("");
}
